import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Col, Row } from 'react-bootstrap';
import CustomContainer from '../../components/CustomContainer';
import { useLoaderContext } from '../../components/loader/LoaderContext';
import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import CustomCard from '../../components/CustomCard';
import DashboardOccupancyChart from './DashboardOccupancyChart';
import DashboardStats from './DashboardStats';
import DashboardGlobalStats from './DashboardGlobalStats';
import GuestsByAgeChart from './GuestsByAgeChart';
import { Actions } from '../../../client/Actions';

const incomeMonthData = [
  { month: 'Grudzień', income: 1100 },
  { month: 'Styczeń', income: 1200 },
  { month: 'Luty', income: 1900 },
  { month: 'Marzec', income: 1500 },
  { month: 'Kwiecień', income: 2100 },
  { month: 'Maj', income: 2400 },
];

const DashboardPage = () => {
  const { showLoader, hideLoader } = useLoaderContext();
  const [stats, setStats] = useState(null);
  const [occupancyMonthData, setOccupancyMonthData] = useState(null);
  const [incomeMonthData, setIncomeMonthData] = useState([]);
  const [guestsByAgeData, setGuestsByAgeData] = useState([]);

  useEffect(() => {
    showLoader();
    Actions.get('/statistics/dashboard', (res) => {
      setStats(res);
    });
  }, []);

  useEffect(() => {
    Actions.get('/statistics/occupancy/by-months', (res) => {
      setOccupancyMonthData(res);
    });
  }, []);

  useEffect(() => {
    Actions.get('/statistics/income/by-months', (res) => {
      setIncomeMonthData(res);
    });
  }, []);

  useEffect(() => {
    Actions.get('/statistics/guests/by-age', (res) => {
      const transformed = Object.entries(res).map(([name, value]) => ({
        name,
        value,
      }));
      setGuestsByAgeData(transformed);
    });
  }, []);

  useEffect(() => {
    if (
      stats ||
      occupancyMonthData ||
      incomeMonthData.length ||
      guestsByAgeData
    ) {
      hideLoader();
    } else {
      showLoader();
    }
  }, [stats, occupancyMonthData, incomeMonthData, guestsByAgeData]);

  return (
    <CustomContainer title={'Panel główny'}>
      {stats && <Row className="mb-4">{<DashboardStats stats={stats} />}</Row>}

      <Row className="mb-4">
        <DashboardOccupancyChart occupancyMonthData={occupancyMonthData} />
        <GuestsByAgeChart data={guestsByAgeData} />
        {incomeMonthData.length > 0 && (
          <CustomCard
            shadow={false}
            width={6}
            title={'Dochód - ostatnie 6 miesięcy'}
          >
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={incomeMonthData}>
                <XAxis dataKey="month" />
                <YAxis unit="zł" />
                <Tooltip
                  formatter={(value) => [`${value} zł`, 'Dochód']}
                  labelFormatter={(label) => `Miesiąc: ${label}`}
                />
                <Bar
                  dataKey="income"
                  name="Dochód"
                  fill="#10b981"
                  radius={[10, 10, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </CustomCard>
        )}
      </Row>

      {stats && (
        <Row>
          {' '}
          <DashboardGlobalStats stats={stats} />
        </Row>
      )}
    </CustomContainer>
  );
};

export default DashboardPage;
